import { render, staticRenderFns } from "./TheWindowAsideRight.vue?vue&type=template&id=7fddf822&scoped=true"
import script from "./TheWindowAsideRight.vue?vue&type=script&lang=js"
export * from "./TheWindowAsideRight.vue?vue&type=script&lang=js"
import style0 from "./TheWindowAsideRight.vue?vue&type=style&index=0&id=7fddf822&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fddf822",
  null
  
)

export default component.exports